import React from 'react';
import './Showreel.css';
import SiteHeader from '../Views/SiteHeader';
import ContactFooter from '../Components/ContactFooter';

const Showreel = () => {
  return (
    <div className="showreel-page">
      <SiteHeader />

      <main className="showreel-main">
        <div className="showreel-layout">
          <aside className="showreel-sidebar">
            <h1 className="showreel-title">Motion Showreel</h1>
            <p className="showreel-meta">2022 – Present</p>

            <div className="showreel-info">
              <div className="showreel-info__head">Project Information</div>
              <p className="showreel-info__copy">
                A selection of motion design over the past couple of years. A
                mixture of client work, unused motion concepting and personal
                projects.
              </p>
            </div>
          </aside>

          <div className="showreel-content">
            <div className="showreel-video-container">
              <video
                controls
                playsInline
                preload="auto"
                className="showreel-video"
                poster="/images/showreel-poster.jpg"
              >
                <source src="/videos/showreel-full.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </main>

      <ContactFooter />
    </div>
  );
};

export default Showreel;
